import React from 'react';
import classNames from 'classnames';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Rating from '@components/@core/Rating';

const PopularProduct = ({ className, logo, title, score, recommendation, onClick, onReview }) => (
    <div className={classNames('popular-product', className)} onClick={onClick}>
        <div className="title">
            <p className="dsl-b16 bold text-center mt-3 mb-2">{title}</p>
        </div>
        <Avatar type="logo" url={logo || '/images/default_company.svg'} size="large" borderColor="#e0e0e0" borderWidth={2} />
        <div className="d-flex justify-content-between mb-2">
            <Rating score={score} showScore={false} />
        </div>
        <p className="dsl-m14 text-center mb-0">{recommendation}% Recommended</p>
        <Button name="ADD REVIEW" type="link" onClick={onReview} />
    </div>
);

export default PopularProduct;
